import { isEmpty,isNil, not } from 'ramda'

export const isNotNil = (value: unknown) => not(isNil(value))
export const isNotEmpty = (value: unknown) => not(isEmpty(value))
export const isNotNilOrEmpty = (value: unknown) => isNotNil(value) && isNotEmpty(value)
export const isNilOrEmpty = (value: unknown) => isNil(value) || isEmpty(value)
